<div class="grey-bg" *ngIf="schedulesWithAssistanceBenefits.length > 0">
  <swiper-container #slides slides-per-view="1" (swiperslidechange)="slideDidChange()" pager="false" parallax="false">
    <swiper-slide *ngFor="let schedule of schedulesWithAssistanceBenefits; let i = index">
      <!-- <div class="arrows" *ngIf="this.sharedConfig.schedulesWithAssistanceBenefits.length > 1">
                    <ion-icon class="left icon-fill-primary" [class.disabled]="i === 0" (click)="prevSlide()"
                      src="assets/icon/genetic-icons/chevron-left.svg"></ion-icon>
                    <ion-icon class="right icon-fill-primary"
                      [class.disabled]="i === this.sharedConfig.schedulesWithAssistanceBenefits.length - 1" (click)="nextSlide()"
                      src="assets/icon/genetic-icons/chevron-right.svg"></ion-icon>
                  </div> -->
      <div class="slider-wrapper">
        <div class="sticky-header">
          <div class="limit-width-on-desktop-float p-20">
            <div class="header-section">
              <div class="main-heading">
                <h2 class="h2-bold">Emergency?</h2>
              </div>
              <div class="heading-content">
                <p>How can we help you today?</p>
              </div>
            </div>
            <div class="top-section">
              <ion-icon *ngIf="schedulesWithAssistanceBenefits.length > 1" class="left icon-fill-primary" [class.disabled]="i === 0" (click)="prev()"
                src="assets/icon/genetic-icons/chevron-left.svg"></ion-icon>
              <client-card
                [quoteOrPolicy]="'Policy'"
                [insurer_id]="schedule.insurer_id"
                [clientName]="clientName"
                [policy_number]="schedule.policy_number"
                [effective_date]="schedule.effective_date.split('T')[0].substring(0, 10)"
              ></client-card>
              <ion-icon class="right icon-fill-primary" *ngIf="schedulesWithAssistanceBenefits.length > 1"
                [class.disabled]="i === schedulesWithAssistanceBenefits.length - 1" (click)="next()"
                src="assets/icon/genetic-icons/chevron-right.svg"></ion-icon>
            </div>
          </div>
        </div>
        <div class="asset-section">
          <div class=" card-wrapper limit-width-on-desktop-float">
            <div [ngClass]="{'padding-bottom': this.emergencyService?.selectedAssetsArray?.length > 0}">
              <ion-row *ngFor="let emergencyCategory of emergencyCategoriesPerInsurer">
                <ion-item
                  mode="md"
                  lines="none"
                  (click)="addOrRemoveAssets(emergencyCategory, emergencyCategory.description, emergencyCategory.selected, schedule.policy_number)"
                >
                  <!-- HOME ASSIST ASSET -->
                  <svg
                    class="category-asset"
                    *ngIf="emergencyCategory.image_name === 'Home-assist'"
                    slot="start"
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 56 56"
                  >
                    <path
                      id="Path-Copy"
                      class="icon-fill-shade-2"
                      d="M8.33,2.62A2.74,2.74,0,0,0,5.7,4.82l-.33,0A2.38,2.38,0,0,0,3.06,7.25a2.53,2.53,0,0,0,0,.28H13.75a2.25,2.25,0,0,0,.11-.68,2,2,0,0,0-1.93-2,1.85,1.85,0,0,0-.93.25A2.76,2.76,0,0,0,8.33,2.62Z"
                    />
                    <path
                      id="Path-Copy-2"
                      data-name="Path-Copy"
                      class="icon-fill-shade-4"
                      d="M15.87,5.07a5,5,0,0,0-4.78,4,3.86,3.86,0,0,0-.6,0,4.34,4.34,0,0,0-4.2,4.46c0,.17,0,.33,0,.5H25.72a3.93,3.93,0,0,0,.2-1.24A3.62,3.62,0,0,0,22.41,9a3.37,3.37,0,0,0-1.69.46A5,5,0,0,0,15.87,5.07Z"
                    />
                    <path
                      class="icon-fill-shade-2"
                      d="M43.13,18l-3.49,1.87-2.37,3-1,4-.66,2.43-2.33-2.83-1.5,2.54L31,32.42v3.37L32.86,40l2.08,2.6,1.33,1.46h8.4l3.49-1.79,2.41-3.38a16.89,16.89,0,0,0,.71-4A24.51,24.51,0,0,0,50,29a25.88,25.88,0,0,0-2-3.2l-.79,2.95-1.62,2.6-.45-1.92-.42-2.61L43.34,25l-.92-2.74L43,19.45Z"
                    />
                    <path class="icon-fill-shade-2" d="M20.08,37.86H15.49V33.13h4.59Z" />
                    <rect class="icon-fill-shade-1" x="3.37" y="44.62" width="17.22" height="1.61" />
                    <rect class="icon-fill-shade-2" x="23.48" y="47.68" width="17.22" height="1.61" />
                    <rect class="icon-fill-shade-1" x="26.48" y="44.62" width="29.52" height="1.61" />
                    <path
                      d="M8.89,24.71A3.5,3.5,0,0,1,11,22.36,1.23,1.23,0,0,0,11.75,21a10,10,0,0,1,0-1.55c0-.43.23-.7.59-.71a.65.65,0,0,1,.66.71c0,.52,0,1,0,1.62l1.06-.67c.72-.46,1.44-.92,2.15-1.39a.51.51,0,0,0,.24-.34c0-1.31,0-2.62,0-4H13v1.48a1.78,1.78,0,0,1,0,.46.57.57,0,0,1-.67.48.56.56,0,0,1-.55-.58c0-.46,0-.92,0-1.38v-.47l-.41,0a.65.65,0,0,1-.7-.72c0-.84,0-1.67,0-2.51,0-.51.22-.72.72-.72h6.75c.51,0,.72.21.73.71,0,.78,0,1.56,0,2.35s-.17.86-.86.89l-.23,0V18l.41-.23C20.07,16.51,22,15.28,23.92,14a2.79,2.79,0,0,1,3.35,0c1.54,1,3.1,2,4.65,3a1.42,1.42,0,0,1,.34.25.56.56,0,0,1,.08.76.57.57,0,0,1-.76.24,3.78,3.78,0,0,1-.43-.26c-1.52-1-3-1.94-4.55-2.93a1.65,1.65,0,0,0-2,0Q17.78,19.49,11,23.86a1.44,1.44,0,0,0-.76,1.62,1.42,1.42,0,0,0,2.2.81c1.64-1,3.27-2.1,4.9-3.15,2.57-1.65,5.15-3.3,7.71-5a.93.93,0,0,1,1.18,0c3.14,2,6.3,4,9.45,6.08l.4.25,1.12-2.62-.69-.45L34,19.84a.66.66,0,0,1-.3-.92c.19-.33.58-.39,1-.13l3.13,2a29,29,0,0,1,2.25-2,20.36,20.36,0,0,1,2.39-1.3l.11,0c.43-.14.89-.31,1.26.08s.2.84,0,1.26A7.59,7.59,0,0,0,43.27,23a3.64,3.64,0,0,0,.83,1.8A7.15,7.15,0,0,1,46,29.57a1.37,1.37,0,0,0,0,.18,5.9,5.9,0,0,0,1.06-2.94,7.06,7.06,0,0,1,.09-1,.7.7,0,0,1,1.18-.4,1.71,1.71,0,0,1,.37.39A17.46,17.46,0,0,1,51,30c.18.48.05.83-.33,1s-.64-.07-.85-.53c-.45-1-.92-2-1.39-3l-.14,0a9.22,9.22,0,0,1-.23.94,8.27,8.27,0,0,1-2,3.29,1.84,1.84,0,0,1-.67.41c-.47.17-.77,0-.79-.54a9.43,9.43,0,0,1,.09-1.29,5.68,5.68,0,0,0-1.38-4.55A5.78,5.78,0,0,1,42,21c.09-.7.26-1.39.41-2.22a22.59,22.59,0,0,0-2,1.27A9.61,9.61,0,0,0,37,25.94c-.21,1-.25,2-.37,3.07a4.13,4.13,0,0,1-.07.49.73.73,0,0,1-1.18.46,2.47,2.47,0,0,1-.58-.54c-.5-.65-1-1.31-1.46-2-3.47,5.87-2,11.88,3.56,15.64-.14-.69-.29-1.35-.38-2a8.34,8.34,0,0,1,1.23-6.13,7.6,7.6,0,0,1,4.35-2.87c.91-.25,1.41.3,1.1,1.19a5.23,5.23,0,0,0-.28,2.92,3.92,3.92,0,0,0,.7,1.4,7.41,7.41,0,0,1,1.61,3.72,14.8,14.8,0,0,1,0,1.63A8.88,8.88,0,0,0,50.57,35c0-.55,0-1.11-.08-1.67s.19-.79.58-.81.62.25.67.7a10.25,10.25,0,0,1-5.46,10.63,5.81,5.81,0,0,1-3,.78q-15.29,0-30.57,0c-.89,0-1-.12-1-1V37.34c0-.11,0-.22,0-.33a.61.61,0,0,1,.59-.68A.63.63,0,0,1,13,37c0,.75,0,1.51,0,2.26v4.08h9.18V33.06c0-.79.17-1,1-1h5c.64,0,.85.21.85.86V43.33h6c-.38-.35-.7-.65-1-1a12.4,12.4,0,0,1-3.61-6.44A12.67,12.67,0,0,1,31.64,28c.26-.56.54-1.11.85-1.64.51-.88,1.25-.87,1.77,0,.33.57.68,1.14,1.08,1.79.14-.81.27-1.49.35-2.17,0-.11-.15-.28-.27-.35L27.1,20.26c-.42-.27-.83-.56-1.27-.8a.55.55,0,0,0-.47,0q-6.08,3.88-12.13,7.8a.68.68,0,0,0-.23.51c0,2,0,4,0,6a1.94,1.94,0,0,1,0,.42.58.58,0,0,1-.64.53.58.58,0,0,1-.59-.58c0-.13,0-.26,0-.38V27.83a2.66,2.66,0,0,1-2.23-1,7.73,7.73,0,0,1-.61-1.18ZM27.72,43.33V33.38H23.46v9.95Zm14-9.82A5.8,5.8,0,0,0,38,37.31a9.79,9.79,0,0,0,.3,5.84.45.45,0,0,0,.34.19c1.54,0,3.08,0,4.61,0a.75.75,0,0,0,.52-.31A2.42,2.42,0,0,0,44,41.4a6,6,0,0,0-1.43-3.11,4,4,0,0,1-1-2.65C41.61,34.94,41.68,34.25,41.72,33.51ZM11.9,13.35h5.63V12H11.9Z"
                    />
                    <path
                      d="M17.59,38.89H15c-.54,0-.76-.23-.77-.77V32.89c0-.56.23-.79.8-.79h5.19c.59,0,.8.22.8.81,0,1.74,0,3.47,0,5.2,0,.57-.21.78-.79.78Zm-.67-4V33.39H15.47v1.46Zm1.31,0h1.46V33.39H18.23Zm-1.3,1.31H15.46V37.6h1.47Zm2.75,1.46V36.15H18.23v1.46Z"
                    />
                    <path d="M22.53,24.94a3.07,3.07,0,0,1,6.14,0,3.07,3.07,0,1,1-6.14,0Zm1.26,0a1.81,1.81,0,1,0,1.81-1.8A1.79,1.79,0,0,0,23.79,25Z" />
                    <path class="icon-fill-shade-3" d="M27.72,43.33H23.46V33.38h4.26Z" />
                    <path
                      class="icon-fill-primary"
                      d="M41.72,33.51c0,.74-.11,1.43-.12,2.13a4,4,0,0,0,1,2.65A6,6,0,0,1,44,41.4,2.42,2.42,0,0,1,43.76,43a.75.75,0,0,1-.52.31c-1.53,0-3.07,0-4.61,0a.45.45,0,0,1-.34-.19,9.79,9.79,0,0,1-.3-5.84A5.8,5.8,0,0,1,41.72,33.51Z"
                    />
                    <path class="icon-fill-primary" d="M11.9,13.35V12h5.63v1.38Z" />
                    <path class="icon-fill-primary" d="M23.79,25a1.79,1.79,0,0,1,1.81-1.8A1.82,1.82,0,1,1,23.79,25Z" />
                  </svg>
                  <!-- LEGAL ADVICE ASSET -->
                  <svg
                    class="category-asset"
                    *ngIf="emergencyCategory.image_name === 'Legal-advice'"
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 56 56"
                  >
                    <path
                      class="icon-fill-shade-4"
                      d="M28,6.17C22.3,10,16.61,11.86,10.91,10V30.85c0,7.59,11.39,13.29,17.09,19,5.7-5.69,17.09-11.39,17.09-19V10C39.39,11.86,33.7,10,28,6.17Z"
                    />
                    <rect class="icon-fill-shade-1" y="43.41" width="40.41" height="1.61" />
                    <rect class="icon-fill-shade-2" x="15.59" y="46.41" width="40.41" height="1.61" />
                    <rect class="icon-fill-shade-1" x="43.81" y="43.41" width="12.19" height="1.61" />
                    <rect class="legal-cls-4 icon-fill-primary" x="11.83" y="35.66" width="17.44" height="2.97" />
                    <rect class="legal-cls-4 icon-fill-primary" x="10.98" y="38.64" width="19.14" height="3.99" />
                    <rect
                      class="legal-cls-4 icon-fill-light"
                      x="21.96"
                      y="18.56"
                      width="4.33"
                      height="12.27"
                      transform="translate(-10.4 24.29) rotate(-45)"
                    />
                    <rect
                      class="legal-cls-4 icon-fill-light"
                      x="31.52"
                      y="9"
                      width="4.33"
                      height="12.27"
                      transform="translate(-0.84 28.25) rotate(-45)"
                    />
                    <rect
                      class="legal-cls-4 icon-fill-light"
                      x="37.15"
                      y="20.22"
                      width="3.78"
                      height="19.66"
                      transform="translate(-9.82 36.41) rotate(-45)"
                    />
                    <rect
                      class="legal-cls-4 icon-fill-light"
                      x="42.35"
                      y="32.77"
                      width="3.78"
                      height="4.96"
                      transform="translate(-11.97 41.61) rotate(-45)"
                    />
                    <rect
                      class="legal-cls-4 icon-fill-light"
                      x="24.31"
                      y="15.41"
                      width="9.19"
                      height="9.01"
                      transform="translate(-5.62 26.27) rotate(-45)"
                    />
                    <path
                      class="icon-fill-primary"
                      fill-rule="evenodd"
                      d="M10.06,22.59a.78.78,0,0,1,1.1-.09l1.21,1a.78.78,0,0,1-1,1.2l-1.2-1A.78.78,0,0,1,10.06,22.59Z"
                    />
                    <path
                      class="icon-fill-primary"
                      fill-rule="evenodd"
                      d="M10.16,29.79l1.2-1a.78.78,0,0,1,1.1.09A.79.79,0,0,1,12.37,30l-1.21,1a.78.78,0,0,1-1.1-.1A.77.77,0,0,1,10.16,29.79Z"
                    />
                    <path
                      class="icon-fill-primary"
                      fill-rule="evenodd"
                      d="M9,26.74A.78.78,0,0,1,9.8,26h1.57a.79.79,0,1,1,0,1.57H9.8A.78.78,0,0,1,9,26.74Z"
                    />
                  </svg>
                  <!-- MEDICAL ASSISTANCE ASSET -->
                  <svg
                    class="category-asset"
                    *ngIf="emergencyCategory.image_name === 'Medical-assistance'"
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 56 56"
                  >
                    <rect class="icon-fill-shade-1" x="8" y="4.39" width="15" height="23" />
                    <rect class="icon-fill-primary" y="10.39" width="8" height="17" />
                    <rect class="icon-fill-light" x="3" y="13.39" width="5" height="3" />
                    <rect class="icon-fill-light" x="3" y="19.39" width="5" height="3" />
                    <line class="medical-cls-4" x1="11" y1="7.39" x2="12" y2="7.39" />
                    <line class="medical-cls-4" x1="15" y1="7.39" x2="16" y2="7.39" />
                    <line class="medical-cls-4" x1="19" y1="7.39" x2="20" y2="7.39" />
                    <line class="medical-cls-4" x1="11" y1="10.39" x2="12" y2="10.39" />
                    <line class="medical-cls-4" x1="15" y1="10.39" x2="16" y2="10.39" />
                    <line class="medical-cls-4" x1="19" y1="10.39" x2="20" y2="10.39" />
                    <line class="medical-cls-4" x1="11" y1="13.39" x2="12" y2="13.39" />
                    <line class="medical-cls-4" x1="15" y1="13.39" x2="16" y2="13.39" />
                    <line class="medical-cls-4" x1="19" y1="13.39" x2="20" y2="13.39" />
                    <line class="medical-cls-4" x1="11" y1="16.39" x2="12" y2="16.39" />
                    <line class="medical-cls-4" x1="15" y1="16.39" x2="16" y2="16.39" />
                    <line class="medical-cls-4" x1="19" y1="16.39" x2="20" y2="16.39" />
                    <rect class="icon-fill-light" x="8.22" y="19.06" width="18.38" height="14.74" />
                    <path class="icon-fill-primary" d="M8.2,33.69V37h5.72a4.25,4.25,0,0,1,5.64,0H42.44a4.25,4.25,0,0,1,5.64,0H54V33.69Z" />
                    <polygon class="icon-fill-shade-2" points="53.07 29.59 39.41 29.59 39.41 21.89 47.31 21.89 53.07 29.59" />
                    <path class="icon-fill-primary" d="M46.14,22.2c-2,0-6.38,3.24-6.38,5.06s-.63-2.17-.63-2.17l.28-3.2,1.9-.45,4.73.2Z" />
                    <polygon class="icon-fill-shade-2" points="39.63 18.78 39.63 16.95 38.58 15.78 37.47 15.78 36.41 16.9 36.41 18.78 39.63 18.78" />
                    <rect class="icon-fill-shade-3" x="25.38" y="21.89" width="10.25" height="7.7" />
                    <circle class="icon-fill-shade-4" cx="16.91" cy="26.33" r="5.23" />
                    <polygon
                      class="icon-fill-primary"
                      points="19.58 25.23 17.64 25.23 17.64 23.29 15.63 23.29 15.63 25.23 13.68 25.23 13.68 27.25 15.63 27.25 15.63 29.19 17.64 29.19 17.64 27.25 19.58 27.25 19.58 25.23"
                    />
                    <rect class="icon-fill-primary" x="3.9" y="44.79" width="17.22" height="1.61" />
                    <rect class="icon-fill-shade-3" y="28.72" width="8.22" height="1.61" />
                    <rect class="icon-fill-shade-3" y="31.62" width="8.22" height="1.61" />
                    <rect class="icon-fill-shade-3" x="24.59" y="44.79" width="31.41" height="1.61" />
                    <rect class="icon-fill-shade-3" y="47.68" width="31.41" height="1.61" />
                    <path
                      class="icon-fill-primary"
                      d="M39.64,19.48a.56.56,0,0,1-.56-.56V17.44a1,1,0,0,0-1-1,1,1,0,0,0-.73.3,1.1,1.1,0,0,0-.33.77v1.45a.56.56,0,1,1-1.11,0V17.47a2.25,2.25,0,0,1,.65-1.56,2.08,2.08,0,0,1,1.52-.62,2.15,2.15,0,0,1,2.14,2.15v1.48A.55.55,0,0,1,39.64,19.48Z"
                    />
                    <path class="icon-fill-primary" d="M38,14.38a.56.56,0,0,1-.56-.56v-1.2a.56.56,0,0,1,1.11,0v1.2A.56.56,0,0,1,38,14.38Z" />
                    <path
                      class="icon-fill-primary"
                      d="M34.64,15.78a.59.59,0,0,1-.39-.16l-.85-.85a.56.56,0,0,1,.79-.79l.84.85a.56.56,0,0,1,0,.79A.57.57,0,0,1,34.64,15.78Z"
                    />
                    <path
                      class="icon-fill-primary"
                      d="M41.41,15.78a.59.59,0,0,1-.39-.16.56.56,0,0,1,0-.79l.85-.85a.56.56,0,0,1,.78,0,.56.56,0,0,1,0,.79l-.84.85A.61.61,0,0,1,41.41,15.78Z"
                    />
                    <path
                      d="M52.52,40.82H49.77a.56.56,0,1,1,0-1.12h2.75a1,1,0,0,0,.9-1.05V31.5a1.19,1.19,0,0,0-.24-.71l-8.55-11a.85.85,0,0,0-.67-.34H9.48a1,1,0,0,0-.9,1.05V38.65a1,1,0,0,0,.9,1.05h2.75a.56.56,0,0,1,0,1.12H9.48a2.09,2.09,0,0,1-2-2.17V20.53a2.09,2.09,0,0,1,2-2.16H44a1.94,1.94,0,0,1,1.54.77l1.69,2.17,6.87,8.8a2.31,2.31,0,0,1,.47,1.39v7.15A2.09,2.09,0,0,1,52.52,40.82Z"
                    />
                    <path d="M40.75,40.82H21.25a.56.56,0,1,1,0-1.12h19.5a.56.56,0,0,1,0,1.12Z" />
                    <path
                      d="M54,37.53H48.34a.56.56,0,0,1,0-1.11h5.08V34.25H8.58v2.17h5.08a.56.56,0,0,1,0,1.11H8A.56.56,0,0,1,7.47,37V33.69A.56.56,0,0,1,8,33.13H54a.56.56,0,0,1,.56.56V37A.56.56,0,0,1,54,37.53Z"
                    />
                    <path d="M42.18,37.53H19.82a.56.56,0,0,1,0-1.11H42.18a.56.56,0,0,1,0,1.11Z" />
                    <path
                      d="M34.62,30.3H26.48a1.79,1.79,0,0,1-1.79-1.79V22.88a1.79,1.79,0,0,1,1.79-1.79h8.14a1.79,1.79,0,0,1,1.79,1.79v5.63A1.79,1.79,0,0,1,34.62,30.3Zm-8.14-8.1a.68.68,0,0,0-.68.68v5.63a.67.67,0,0,0,.68.68h8.14a.68.68,0,0,0,.68-.68V22.88a.69.69,0,0,0-.68-.68Z"
                    />
                    <path d="M16.74,45.32a5.06,5.06,0,1,1,5.06-5.06A5.07,5.07,0,0,1,16.74,45.32Zm0-9a4,4,0,1,0,4,3.95A4,4,0,0,0,16.74,36.31Z" />
                    <path
                      d="M16.74,42.49A2.23,2.23,0,1,1,19,40.26,2.23,2.23,0,0,1,16.74,42.49Zm0-3.34a1.11,1.11,0,1,0,1.11,1.11A1.11,1.11,0,0,0,16.74,39.15Z"
                    />
                    <path d="M45.26,45.32a5.06,5.06,0,1,1,5.06-5.06A5.07,5.07,0,0,1,45.26,45.32Zm0-9a4,4,0,1,0,4,3.95A4,4,0,0,0,45.26,36.31Z" />
                    <path
                      d="M45.26,42.49a2.23,2.23,0,1,1,2.23-2.23A2.23,2.23,0,0,1,45.26,42.49Zm0-3.34a1.11,1.11,0,1,0,1.11,1.11A1.11,1.11,0,0,0,45.26,39.15Z"
                    />
                    <path
                      d="M53.07,30.3H40.66a2,2,0,0,1-2-2V23.1a2,2,0,0,1,2-2h6.09a.56.56,0,1,1,0,1.11H40.66a.91.91,0,0,0-.9.9v5.19a.9.9,0,0,0,.9.9H53.07a.56.56,0,0,1,0,1.11Z"
                    />
                    <path
                      d="M17.57,29.92H15.76a.56.56,0,0,1-.56-.56V27.77H13.61a.56.56,0,0,1-.56-.56V25.4a.56.56,0,0,1,.56-.56H15.2V23.25a.55.55,0,0,1,.56-.55h1.81a.55.55,0,0,1,.56.55v1.59h1.59a.56.56,0,0,1,.55.56v1.81a.56.56,0,0,1-.55.56H18.13v1.59A.56.56,0,0,1,17.57,29.92Zm-1.26-1.11H17v-1.6a.56.56,0,0,1,.56-.55h1.59V26H17.57A.55.55,0,0,1,17,25.4V23.81h-.7V25.4a.55.55,0,0,1-.55.55h-1.6v.71h1.6a.55.55,0,0,1,.55.55Z"
                    />
                    <path
                      d="M16.66,32.09a5.78,5.78,0,1,1,5.78-5.78A5.79,5.79,0,0,1,16.66,32.09Zm0-10.45a4.67,4.67,0,1,0,4.67,4.67A4.68,4.68,0,0,0,16.66,21.64Z"
                    />
                  </svg>
                  <!-- ROADSIDE ASSISTANCE ASSET -->
                  <svg
                    class="category-asset"
                    *ngIf="emergencyCategory.image_name === 'Roadside-assistance'"
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 56 56"
                  >
                    <polygon
                      class="icon-fill-shade-2"
                      points="24.5 32.61 24.5 21.46 24.14 20.14 22.94 19.85 15.35 20.14 13.7 20.74 12.74 21.99 9.37 26.68 9.01 28.17 9.01 32.61 24.5 32.61"
                    />
                    <polygon
                      class="icon-fill-shade-1"
                      points="24.5 32.61 24.5 27.08 15.71 27.08 13.96 27.62 12.74 29.26 12.05 31.68 12.05 32.61 24.5 32.61"
                    />
                    <path
                      class="icon-fill-primary"
                      fill-rule="evenodd"
                      d="M14,30.5l.05-.19a2.13,2.13,0,0,1,2-1.43h8.43V27.46H15.86a3.55,3.55,0,0,0-3.2,2.68l-.75,3h1.46Z"
                    />
                    <rect class="icon-fill-shade-3" x="25.33" y="42.65" width="29.09" height="1.61" />
                    <rect class="icon-fill-shade-3" x="8.77" y="42.65" width="14.06" height="1.61" />
                    <rect class="icon-fill-primary" x="17.26" y="46.07" width="29.09" height="1.61" />
                    <path
                      id="Path-Copy"
                      class="icon-fill-shade-1"
                      d="M13.7,6.74a5.58,5.58,0,0,0-5.36,4.5,3.78,3.78,0,0,0-.67-.05,4.87,4.87,0,0,0-4.73,5,5.12,5.12,0,0,0,0,.56H24.76A4.5,4.5,0,0,0,25,15.36,4.06,4.06,0,0,0,21,11.19a3.72,3.72,0,0,0-1.89.51A5.62,5.62,0,0,0,13.7,6.74Z"
                    />
                    <path
                      id="Path-Copy-2"
                      data-name="Path-Copy"
                      class="icon-fill-shade-4"
                      d="M23.79,8.09a6.77,6.77,0,0,0-6.5,5.45,5.52,5.52,0,0,0-.81-.06,5.9,5.9,0,0,0-5.72,6.07c0,.23,0,.45,0,.67H37.18a5.14,5.14,0,0,0,.27-1.68,4.92,4.92,0,0,0-4.76-5.06,4.51,4.51,0,0,0-2.3.63A6.82,6.82,0,0,0,23.79,8.09Z"
                    />
                    <g id="icn_options_road-assistance" data-name="icn/options/road-assistance">
                      <path
                        id="Combined-Shape"
                        class="icon-fill-primary"
                        fill-rule="evenodd"
                        d="M18.93,16.48a2.13,2.13,0,0,1,2.13,2.13h0v2.13H16.8V18.61A2.13,2.13,0,0,1,18.93,16.48Zm0,1.42a.71.71,0,0,0-.71.71h0v.71h1.42v-.71a.71.71,0,0,0-.58-.7h-.13ZM22.69,14a.71.71,0,0,1,.08,1l-.91,1.09a.7.7,0,0,1-1,.08.71.71,0,0,1-.09-1l.91-1.08A.72.72,0,0,1,22.69,14Zm-6.51.09.91,1.08a.71.71,0,0,1-1.09.92L15.09,15a.71.71,0,1,1,1.09-.91Zm2.75-1.84a.71.71,0,0,1,.71.71v1.42a.71.71,0,1,1-1.42,0V12.93A.71.71,0,0,1,18.93,12.22Z"
                      />
                      <path
                        id="Path"
                        class="icon-fill-dark"
                        fill-rule="evenodd"
                        d="M43.78,15.06l1.42-.71V27.13a.71.71,0,0,0,1.41.12v-.83a.71.71,0,0,1,1.42,0v.71h0a2.13,2.13,0,0,1-4.25.2V15.06Z"
                      />
                      <g id="Combined-Shape-2" data-name="Combined-Shape">
                        <path
                          class="cls-9"
                          fill-rule="evenodd"
                          d="M44.31,12.72a2.33,2.33,0,0,1,.56,3l-.11.17L36.45,27.44a3.75,3.75,0,0,1,.47.57l.13.22,2.18,3.87h5.26A3.54,3.54,0,0,1,48,35.41v3.08a2.14,2.14,0,0,1-1.92,2.12h-4a4.26,4.26,0,0,1-8,0H20.82a4.26,4.26,0,0,1-8,0H10.41a2.14,2.14,0,0,1-2.12-1.93V28.92a6.46,6.46,0,0,1,1-3.37l.2-.3,2.67-3.81a4.94,4.94,0,0,1,3.77-2.11h7.31a2.12,2.12,0,0,1,2.12,1.92V32.1h.3l2.17-3.87a3.55,3.55,0,0,1,2.07-1.66L41.09,13.05A2.32,2.32,0,0,1,44.31,12.72ZM16.8,36.36a2.84,2.84,0,1,0,2.84,2.84A2.84,2.84,0,0,0,16.8,36.36Zm21.3,0a2.84,2.84,0,1,0,2.84,2.84A2.84,2.84,0,0,0,38.1,36.36Zm6.39-2.84H9.7v5a.71.71,0,0,0,.58.7h2.26A4.26,4.26,0,0,1,21.06,39v.25H33.84A4.26,4.26,0,0,1,42.36,39v.25h3.55a.71.71,0,0,0,.7-.59v-3a2.12,2.12,0,0,0-1.92-2.12Zm0,1.42a.71.71,0,0,1,.71.71v1.42a.71.71,0,0,1-1.42,0V35.65A.71.71,0,0,1,44.49,34.94ZM34,27.84H30.89a2.13,2.13,0,0,0-1.75.91l-.11.17L27.25,32.1H37.6l-1.79-3.18a2.1,2.1,0,0,0-1.65-1.07Zm-10.77-7.1h-7A3.55,3.55,0,0,0,13.43,22l-.16.21L10.6,26.07a5,5,0,0,0-.89,2.51V32.1h1.58l.75-3a3.54,3.54,0,0,1,3.2-2.69H23.9v-5a.71.71,0,0,0-.46-.67l-.12,0Zm.71,7.1H15.47a2.13,2.13,0,0,0-2,1.42l-.06.19-.66,2.65H23.9Zm18.35-14-.09.1L31.81,26.42H34a3.59,3.59,0,0,1,1.34.26l8.34-11.56a1,1,0,0,0-.19-1.33A.94.94,0,0,0,42.25,13.83Z"
                        />
                      </g>
                      <path
                        id="Rectangle"
                        class="icon-fill-dark"
                        d="M23.19,36.36h8.52a.71.71,0,0,1,.71.71h0a.71.71,0,0,1-.71.71H23.19a.71.71,0,0,1-.71-.71h0A.71.71,0,0,1,23.19,36.36Z"
                      />
                    </g>
                  </svg>
                  <!-- ROUTE ASSISTANCE ASSET -->
                  <svg
                    class="category-asset"
                    *ngIf="emergencyCategory.image_name === 'Route-assistance'"
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 56 56"
                  >
                    <path class="icon-fill-shade-4" d="M30.65,30c0-5.33-2.2-24.84-10.7-24.84S7.76,25.59,7.76,30Z" />
                    <path class="icon-fill-shade-2" d="M15.33,30c0-2.91-1.2-13.56-5.84-13.56S2.84,27.59,2.84,30Z" />
                    <rect class="icon-fill-primary" isolation="isolate" opacity="0.6" y="29.99" width="13.1" height="1.5" />
                    <rect class="icon-fill-primary" isolation="isolate" opacity="0.6" x="43.9" y="32.95" width="12.1" height="1.5" />
                    <rect class="icon-fill-primary" isolation="isolate" opacity="0.6" x="4" y="32.95" width="8.1" height="1.5" />
                    <polygon class="icon-fill-light" points="12.52 31.66 21.63 31 18.71 25.67 17.26 24.19 13.59 24.19 12.52 31.66" />
                    <circle class="icon-fill-light" cx="28" cy="20.5" r="4.41" />
                    <rect class="icon-fill-shade-3" x="36.31" y="13.75" width="17.1" height="1.5" />
                    <rect class="icon-fill-shade-3" x="37.86" y="17.08" width="10.1" height="1.5" />
                    <path
                      class="icon-fill-shade-1"
                      d="M28,10.58A10.35,10.35,0,0,0,17.64,20.93C17.63,28.45,28,38.82,28,38.82S38.36,28.41,38.36,20.93A10.35,10.35,0,0,0,28,10.58Zm0,14.71a4.71,4.71,0,1,1,4.71-4.71A4.71,4.71,0,0,1,28,25.29Z"
                    />
                    <path
                      class="icon-fill-primary"
                      d="M23.29,20.58a4.71,4.71,0,0,1,8-3.37c0-.26,0-.52,0-.78a9.21,9.21,0,0,0-2-5.76,9.36,9.36,0,0,0-1.3-.09A10.35,10.35,0,0,0,17.64,20.93a12,12,0,0,0,.79,4A9.22,9.22,0,0,0,26,24.81,4.7,4.7,0,0,1,23.29,20.58Z"
                    />
                    <g id="map">
                      <polyline
                        class="icon-stroke-dark"
                        fill="none"
                        stroke-width="1.5px"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        points="18.11 24.19 13.59 24.19 10.56 45.42 19.66 40.87 28 44.57 36.34 40.87 45.44 45.42 42.41 24.19 37.89 24.19"
                      />
                      <g id="pin">
                        <path
                          class="icon-stroke-dark"
                          fill="none"
                          stroke-width="1.5px"
                          stroke-miterlimit="10"
                          d="M38.36,20.93C38.36,28.41,28,38.82,28,38.82S17.63,28.45,17.64,20.93a10.36,10.36,0,0,1,20.72,0Z"
                        />
                        <path
                          class="icon-stroke-dark"
                          fill="none"
                          stroke-width="1.5px"
                          stroke-miterlimit="10"
                          d="M32.71,20.58A4.71,4.71,0,1,1,28,15.88,4.71,4.71,0,0,1,32.71,20.58Z"
                        />
                      </g>
                    </g>
                  </svg>
                  <!-- TAKE ME ASSET -->
                  <svg
                    class="category-asset"
                    *ngIf="emergencyCategory.image_name === 'Take-me'"
                    id="Layer_1"
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 56 56"
                  >
                    <path
                      id="Path-Copy"
                      class="icon-fill-shade-4"
                      d="M16.68,5.6a6.76,6.76,0,0,0-6.49,5.46A5.55,5.55,0,0,0,9.37,11a5.9,5.9,0,0,0-5.72,6.07,5.17,5.17,0,0,0,0,.68H30.08a5.25,5.25,0,0,0,.27-1.69A4.92,4.92,0,0,0,25.58,11a4.56,4.56,0,0,0-2.3.63A6.81,6.81,0,0,0,16.68,5.6Z"
                    />
                    <rect class="icon-fill-shade-1" x="11.76" y="8.67" width="3.94" height="1.55" rx="0.77" />
                    <path class="icon-fill-shade-3" d="M33.29,40.08H22.71V34.21A3.19,3.19,0,0,1,25.9,31h4.2a3.19,3.19,0,0,1,3.19,3.19Z" />
                    <polygon
                      class="icon-fill-shade-1"
                      points="28 14.5 20.21 14.5 18.18 15.33 17.04 16.58 16.44 18.57 15.42 23.68 15.92 24.98 39.46 24.98 40.29 24.7 40.51 23.33 39.33 17.43 38.17 15.61 36.24 14.5 28 14.5"
                    />
                    <path class="icon-fill-primary" d="M29.7,14.41C25.82,14.41,17.18,25,17.18,25l-2-.79,1.51-6.76,1.51-2.1,2-.83Z" />
                    <rect class="icon-fill-primary" x="24.22" y="11.39" width="7.55" height="2.36" />
                    <rect class="icon-fill-shade-3" y="44.79" width="24.09" height="1.61" />
                    <rect class="icon-fill-shade-2" y="28.69" width="13.09" height="1.61" />
                    <polygon class="icon-fill-shade-4" points="13.09 31.62 12.09 33.23 0 33.23 0 31.62 13.09 31.62" />
                    <rect class="icon-fill-shade-3" x="36.91" y="48.49" width="19.09" height="1.61" />
                    <rect class="icon-fill-primary" x="32.98" y="44.79" width="17.22" height="1.61" />
                    <path
                      class="icon-fill-primary"
                      opacity="0.6"
                      isolation="isolate"
                      d="M49.64,6.63A3.35,3.35,0,0,1,53,10h0V20.07a3.36,3.36,0,0,1-2.8,3.31h0V38.23l-1.4,3V23.38A3.36,3.36,0,0,1,46,20.07h0V10a3.35,3.35,0,0,1,3.36-3.36h.28Z"
                    />
                    <ellipse class="icon-fill-light" isolation="isolate" cx="49.5" cy="20.07" rx="1.75" ry="1.68" />
                    <ellipse class="icon-fill-light" isolation="isolate" cx="49.5" cy="15.03" rx="1.75" ry="1.68" />
                    <ellipse class="icon-fill-light" isolation="isolate" cx="49.5" cy="9.99" rx="1.75" ry="1.68" />
                    <path
                      id="Combined-Shape"
                      class="icon-fill-primary"
                      opacity="0.6"
                      isolation="isolate"
                      d="M46,10V20.07a3.36,3.36,0,0,0,2.8,3.31V44.79h1.4V23.38a3.36,3.36,0,0,0,2.74-2.67l-2.35-4.36a1.85,1.85,0,0,1-1.09.36A1.71,1.71,0,0,1,47.75,15,1.69,1.69,0,0,1,49,13.42L46.35,8.49A3.41,3.41,0,0,0,46,10Zm3.5,8.4a1.68,1.68,0,1,1-1.75,1.68A1.71,1.71,0,0,1,49.5,18.39Z"
                    />
                    <g id="taxi">
                      <path
                        class="icon-stroke-dark"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5px"
                        d="M44,40.08c.08-4.17-.42-12.73-3.15-15.1H15.16c-2.73,2.37-3.23,10.93-3.15,15.1Z"
                      />
                      <path
                        class="icon-stroke-dark"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5px"
                        d="M33.29,40.08H22.71V34.21A3.19,3.19,0,0,1,25.9,31h4.2a3.19,3.19,0,0,1,3.19,3.19Z"
                      />
                      <circle
                        class="icon-stroke-dark"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5px"
                        cx="17.43"
                        cy="31.78"
                        r="1.51"
                      />
                      <circle
                        class="icon-stroke-dark"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5px"
                        cx="38.57"
                        cy="31.78"
                        r="1.51"
                      />
                      <path
                        class="icon-stroke-dark"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5px"
                        d="M18.18,40.08v3a1.5,1.5,0,0,1-1.51,1.51H15.16a1.51,1.51,0,0,1-1.51-1.51v-3h4.53"
                      />
                      <path
                        class="icon-stroke-dark"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5px"
                        d="M37.82,40.08v3a1.5,1.5,0,0,0,1.51,1.51h1.51a1.51,1.51,0,0,0,1.51-1.51v-3H37.82"
                      />
                      <path
                        class="icon-stroke-dark"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5px"
                        d="M15.16,25l1.51-7.55a4.52,4.52,0,0,1,4.53-3H34.8a4.52,4.52,0,0,1,4.53,3L40.84,25"
                      />
                      <path
                        class="icon-stroke-dark"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5px"
                        d="M25.22,11.39h5.55a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H24.22a0,0,0,0,1,0,0v-2A1,1,0,0,1,25.22,11.39Z"
                      />
                    </g>
                    <path
                      class="icon-fill-shade-3"
                      d="M14,8.4h-.1V8.28a.17.17,0,0,0-.17-.17h0v-1h0a.09.09,0,1,0,0-.18h-.19V6.73h0a1,1,0,0,0-1-1H9.94a.81.81,0,0,0-.57-.56l-.21,0a.82.82,0,0,0-.78.59H5.79a1,1,0,0,0-1,1v.19h-.2a.09.09,0,1,0,0,.18h0v1h0a.18.18,0,0,0-.18.17V8.4H4.35a.21.21,0,0,0-.21.2v.07h1.8V8.6a.2.2,0,0,0-.2-.2h-.1V8.28a.18.18,0,0,0-.17-.17h0v-1h0a.09.09,0,1,0,0-.18H5.28V6.73a.52.52,0,0,1,.51-.52H8.37a.83.83,0,0,0,.55.56V17.88h0a.08.08,0,0,0-.08.08v1.4h0a.09.09,0,0,0-.09.09v1.92H8.63a.27.27,0,0,0-.28.28v.19H8.18a.28.28,0,0,0-.28.28v5.1a.23.23,0,0,0-.23.23V28H7.43a.41.41,0,0,0-.41.41v.26h4.27v-.26a.4.4,0,0,0-.4-.41h-.25v-.57a.22.22,0,0,0-.22-.23v-5.1a.28.28,0,0,0-.29-.28H10v-.19a.28.28,0,0,0-.28-.28H9.62V19.45a.09.09,0,0,0-.08-.09h0V18a.09.09,0,0,0-.08-.08h0V6.76a.8.8,0,0,0,.55-.55h2.58a.52.52,0,0,1,.52.52v.19h-.19a.09.09,0,1,0,0,.18h0v1h0a.18.18,0,0,0-.18.17V8.4h-.09a.2.2,0,0,0-.2.2v.07h1.79V8.6A.2.2,0,0,0,14,8.4Z"
                    />
                    <rect class="icon-fill-shade-1" x="2.76" y="8.67" width="3.94" height="1.55" rx="0.77" />
                    <path
                      class="icon-fill-primary"
                      d="M3,9.7a.78.78,0,0,1,.77-.78H6.17a.79.79,0,0,1,.4.13.77.77,0,0,0-.65-.38H3.53a.78.78,0,0,0-.77.78.75.75,0,0,0,.38.65A.71.71,0,0,1,3,9.7Z"
                    />
                    <path
                      class="icon-fill-primary"
                      d="M12,9.7a.78.78,0,0,1,.77-.78h2.39a.79.79,0,0,1,.4.13.77.77,0,0,0-.65-.38H12.53a.78.78,0,0,0-.77.78.75.75,0,0,0,.38.65A.71.71,0,0,1,12,9.7Z"
                    />
                    <path
                      class="icon-fill-primary"
                      fill-rule="evenodd"
                      d="M3.12,11.86a.3.3,0,0,1,0-.41L3.46,11a.29.29,0,0,1,.41,0,.3.3,0,0,1,0,.41l-.38.45A.29.29,0,0,1,3.12,11.86Z"
                    />
                    <path class="icon-fill-primary" fill-rule="evenodd" d="M5.8,11.83l-.38-.45A.29.29,0,0,1,5.87,11l.37.44a.29.29,0,1,1-.44.38Z" />
                    <path
                      class="icon-fill-primary"
                      fill-rule="evenodd"
                      d="M4.66,12.25A.29.29,0,0,1,4.37,12v-.58a.3.3,0,1,1,.59,0V12A.29.29,0,0,1,4.66,12.25Z"
                    />
                    <path
                      class="icon-fill-primary"
                      fill-rule="evenodd"
                      d="M12.18,11.86a.29.29,0,0,1,0-.41l.37-.44a.29.29,0,0,1,.45.37l-.38.45A.29.29,0,0,1,12.18,11.86Z"
                    />
                    <path
                      class="icon-fill-primary"
                      fill-rule="evenodd"
                      d="M14.86,11.83l-.38-.45a.3.3,0,0,1,0-.41.29.29,0,0,1,.41,0l.38.44a.3.3,0,0,1,0,.41A.29.29,0,0,1,14.86,11.83Z"
                    />
                    <path
                      class="icon-fill-primary"
                      fill-rule="evenodd"
                      d="M13.73,12.25a.3.3,0,0,1-.3-.29v-.58a.31.31,0,0,1,.3-.3.3.3,0,0,1,.29.3V12A.29.29,0,0,1,13.73,12.25Z"
                    />
                  </svg>
                  <ion-label>
                    {{ emergencyCategory.description }}
                  </ion-label>
                  <ion-icon class="checked icon-fill-primary" *ngIf="emergencyCategory.selected" src="assets/icon/genetic-icons/tick-primary.svg" slot="end"></ion-icon>
                </ion-item>
              </ion-row>
            </div>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>
  <div class="footer-button-wrapper" *ngIf="this.emergencyService?.selectedAssetsArray?.length > 0">
    <div class="fade"></div>
    <div class="footer-button-background">
      <ion-button
        mode="ios"
        class="footer-button limit-width-desktop-on-button"
        expand="block"
        (click)="
          showActionSheet(
            this.schedulesWithAssistanceBenefits[getCurrentSliderIndex].insurer_id
          )
        "
      >
        Call emergency
      </ion-button>
    </div>
  </div>
</div>